import tableAppProviders from './tableOculusInAppPurchasesProvider';

export default {
  title: 'SKU Virtual Tickets providers',
  attributeName: 'oculusInAppProvider',
  getURL: 'appId/oculusInAppProvider',
  createURL: 'appId/oculusInAppProvider',
  updateURL: 'appId/oculusInAppProvider',
  removeURL: 'appId/oculusInAppProvider',
  sessionParams: ['appId'],
  noArea: true,
  tableConfig: tableAppProviders,
  autoUpdate: true,
};
